module.exports = __webpack_public_path__ + "static/img/Gemini.1f98983.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Gemini.svg
// module id = 1398
// module chunks = 0